import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { Motion, spring } from 'react-motion';

import { trashFull, trashItem } from '../../actions';

import TrashFull from './img/trash-full.svg'
import TrashEmpty from './img/trash.svg'

import { withTranslation } from 'react-i18next'

const images = {
  TrashFull: TrashFull,
  TrashEmpty: TrashEmpty
}

class Graphics extends Component {
  componentWillMount() {
    for(const image in images){
      if(!image.replace(this.props.type, '').includes(0)){
        const img = new Image();
        img.src = images[image];
      }
    }
  }

  render(){
    return(
      <div aria-label={this.props.t("Trash can")} role="img" className="graphics">
         <img
             style={{ pointerEvents: "none" }}
             src={(this.props.full)?images[this.props.type+"Full"]:images[this.props.type+"Empty"]}
             alt={this.props.t('Trash')}/>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
    return {
      full: state.trash.full,
      count: state.trash.count,
      type: state.trash.type
    }
}

export default connect(mapStateToProps, {
    trashFull,
    trashItem
})(withTranslation()(Graphics));
